import Container from 'react-bootstrap/Container';
import { Modal, Button } from "react-bootstrap";

function ModalTextoSimples({ show, setShow, modalTitle, text }) {

  console.log('#### Iniciando RespPendItemModal ####');

  return (
    <Modal show={show} backdrop="static" keyboard={false} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <div className="form-control-plaintext">
            {text ? text : "Sem informações"}
          </div>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-center">
          <Button variant="secondary" onClick={() => setShow(false)}>FECHAR</Button>
        </div>
      </Modal.Footer>
    </Modal >
  );
}

export default ModalTextoSimples;
